<div class="patient-crud">
  <div class="d-flex">
    <h2 class="mb-4" [hidden]="hideForm" *ngIf="!patientForm.get('anonymous').value && !patientForm.get('pseudonymous').value">{{_(KEYS.CRUD.PATIENT)}}
    </h2>
    <h2 class="mb-4" [hidden]="hideForm" *ngIf="!!patientForm.get('anonymous').value">{{_(KEYS.CRUD.PATIENT_ANONYMOUS)}}</h2>
    <h2 class="mb-4" *ngIf="hideForm && !!patientForm.get('anonymous').value">{{_(KEYS.CRUD.PATIENT_ANONYMOUS)}}</h2>
    <h2 class="mb-4" [hidden]="hideForm" *ngIf="!!patientForm.get('pseudonymous').value">{{_(KEYS.CRUD.PATIENT_PSEUDONYMOUS)}}</h2>
    <h2 class="mb-4" *ngIf="hideForm && !!patientForm.get('pseudonymous').value">{{_(KEYS.CRUD.PATIENT_PSEUDONYMOUS)}}</h2>

    <ng-container *ngIf="hideForm && !patientForm.get('anonymous').value && !patientForm.get('pseudonymous').value">
      <h2 class="mb-4">{{_(KEYS.CRUD.PATIENT)}}: </h2>
      <div class="patient-data-small">
        {{patientForm.get('lastName').value}}, {{patientForm.get('firstName').value}} - *{{patientForm.get('birthDate').value}}
      </div>
    </ng-container>

    <div class="quota-pills ml-auto" *ngIf="surveyLimit.max || thiemeCap.loaded">
      <div
        class="quota-pill"
        [ngClass]="'quota-' + surveyLimitState"
        *ngIf="surveyLimit.max"
        title="{{_(KEYS.CRUD.SURVEY_LIMIT_INFO, surveyLimit)}}"
      >
        <span class="quota-dot"></span>
        <span class="quota-label">{{_(KEYS.CRUD.SURVEYS)}}</span>
        <span class="quota-value">{{surveyLimit.current}}/{{surveyLimit.max}}</span>
      </div>
      <div
        class="quota-pill"
        [ngClass]="'quota-' + thiemeCapState"
        *ngIf="thiemeCap.loaded"
        title="{{_(KEYS.CRUD.THIEME_FORMS)}}: {{_(KEYS.CRUD.THIEME_CAP_INFO, thiemeCapVars)}}"
      >
        <span class="quota-dot"></span>
        <span class="quota-label">{{_(KEYS.CRUD.THIEME_FORMS)}}</span>
        <span class="quota-value">{{thiemeCap.used}}/{{thiemeCap.limit}}</span>
      </div>
    </div>
  </div>

  <!-- Pseudonymous allocation form -->
  <form [formGroup]="patientForm" class="pseudonymous-form" *ngIf="patientForm.get('pseudonymous').value">
    <div class="form-group">
      <label for="pseudoId">{{_(KEYS.CRUD.PSEUDO_ID)}}</label>
      <input
        class="form-control" id="pseudoId"
        [placeholder]="_(KEYS.CRUD.ENTER_PSEUDO_ID)"
        formControlName="pseudoId"
        name="pseudoId">
    </div>
  </form>

  <!-- Unified master data form (standard + custom fields in grid layout) -->
  <div *ngIf="!hideForm && !patientForm.get('anonymous').value && !patientForm.get('pseudonymous').value">
    <form class="master-data-form">
      <div class="master-data-grid" [style.grid-template-columns]="getGridTemplateColumns()">
        <ng-container *ngFor="let position of effectiveLayout.positions">

          <!-- HR element (divider) -->
          <div
            *ngIf="position.fieldType === 'hr'"
            class="grid-field-cell hr-cell"
            [style.grid-column]="getGridColumn(position)"
            [style.grid-row]="getGridRow(position)"
          >
            <hr>
          </div>

          <!-- Standard field -->
          <ng-container *ngIf="position.fieldType === 'standard'">
            <div
              class="grid-field-cell form-group"
              [style.grid-column]="getGridColumn(position)"
              [style.grid-row]="getGridRow(position)"
              [formGroup]="patientForm"
            >
              <!-- Gender -->
              <ng-container *ngIf="position.fieldKey === 'gender'">
                <label for="gender" [title]="_(KEYS.CRUD.GENDER)">{{_(KEYS.CRUD.GENDER)}}</label>
                <select class="form-control" id="gender" name="gender" formControlName="gender">
                  <option [value]="null" [hidden]="true">{{_(KEYS.CRUD.ENTER_CHOICE)}}</option>
                  <option value="male">{{_(KEYS.CRUD.MALE)}}</option>
                  <option value="female">{{_(KEYS.CRUD.FEMALE)}}</option>
                  <option value="diverse">{{_(KEYS.CRUD.DIVERSE)}}</option>
                </select>
              </ng-container>

              <!-- First Name -->
              <ng-container *ngIf="position.fieldKey === 'firstName'">
                <label for="firstName" [title]="_(KEYS.CRUD.FIRSTNAME)">{{_(KEYS.CRUD.FIRSTNAME)}}</label>
                <input
                  class="form-control" id="firstName"
                  [placeholder]="_(KEYS.CRUD.ENTER_FIRSTNAME)"
                  formControlName="firstName"
                  name="firstName">
              </ng-container>

              <!-- Last Name -->
              <ng-container *ngIf="position.fieldKey === 'lastName'">
                <label for="lastName" [title]="_(KEYS.CRUD.LASTNAME)">{{_(KEYS.CRUD.LASTNAME)}}</label>
                <input
                  class="form-control"
                  id="lastName"
                  [placeholder]="_(KEYS.CRUD.ENTER_LASTNAME)"
                  formControlName="lastName"
                  name="lastName">
              </ng-container>

              <!-- Birth Date -->
              <ng-container *ngIf="position.fieldKey === 'birthDate'">
                <label for="birthDate" [title]="_(KEYS.CRUD.BIRTHDATE)">{{_(KEYS.CRUD.BIRTHDATE)}}</label>
                <input
                  class="form-control"
                  id="birthDate"
                  [placeholder]="getLocalDateFormat()"
                  formControlName="birthDate"
                  name="birthDate"
                  [attr.data-mask]="getLocalDateFormatMask()"
                  [attr.data-placeholder]="getLocalDateFormat()">
              </ng-container>

              <!-- Zip Code -->
              <ng-container *ngIf="position.fieldKey === 'zipCode'">
                <label for="zipCode" [title]="_(KEYS.CRUD.ZIP_CODE)">{{_(KEYS.CRUD.ZIP_CODE)}}</label>
                <input
                  class="form-control"
                  id="zipCode"
                  [placeholder]="_(KEYS.CRUD.ZIP_CODE)"
                  formControlName="zipCode"
                  name="zipCode">
              </ng-container>

              <!-- City -->
              <ng-container *ngIf="position.fieldKey === 'city'">
                <label for="city" [title]="_(KEYS.CRUD.CITY)">{{_(KEYS.CRUD.CITY)}}</label>
                <input
                  class="form-control"
                  id="city"
                  [placeholder]="_(KEYS.CRUD.CITY)"
                  formControlName="city"
                  name="city">
              </ng-container>

              <!-- Street -->
              <ng-container *ngIf="position.fieldKey === 'street'">
                <label for="street" [title]="_(KEYS.CRUD.STREET)">{{_(KEYS.CRUD.STREET)}}</label>
                <input
                  class="form-control"
                  id="street"
                  [placeholder]="_(KEYS.CRUD.STREET)"
                  formControlName="street"
                  name="street">
              </ng-container>

              <!-- Street Nr -->
              <ng-container *ngIf="position.fieldKey === 'streetNr'">
                <label for="streetNr" [title]="_(KEYS.CRUD.STREET_NR)">{{_(KEYS.CRUD.STREET_NR)}}</label>
                <input
                  class="form-control"
                  id="streetNr"
                  [placeholder]="_(KEYS.CRUD.STREET_NR)"
                  formControlName="streetNr"
                  name="streetNr">
              </ng-container>

              <!-- Address (deprecated) -->
              <ng-container *ngIf="position.fieldKey === 'address'">
                <div class="address-deprecated">
                  <label>{{_(KEYS.CRUD.ADDRESS_DEPRECATED)}}:&nbsp;</label>
                  <span>{{patientForm.get('address').value}}</span>
                  <hr>
                </div>
              </ng-container>

              <!-- Email -->
              <ng-container *ngIf="position.fieldKey === 'email'">
                <label for="email" [title]="_(KEYS.CRUD.EMAIL)">{{_(KEYS.CRUD.EMAIL)}}</label>
                <input
                  class="form-control"
                  id="email"
                  [placeholder]="_(KEYS.CRUD.EMAIL)"
                  formControlName="email"
                  name="email">
              </ng-container>

              <!-- Location -->
              <ng-container *ngIf="position.fieldKey === 'location'">
                <label for="location" [title]="_(KEYS.CRUD.LOCATION)">{{_(KEYS.CRUD.LOCATION)}}</label>
                <input
                  class="form-control"
                  id="location"
                  [placeholder]="_(KEYS.CRUD.ENTER_LOCATION)"
                  formControlName="location"
                  name="location">
              </ng-container>

              <!-- Pseudo ID -->
              <ng-container *ngIf="position.fieldKey === 'pseudoId'">
                <label for="pseudoId" [title]="_(KEYS.CRUD.PSEUDO_ID)">{{_(KEYS.CRUD.PSEUDO_ID)}}</label>
                <input
                  class="form-control"
                  id="pseudoId"
                  [placeholder]="_(KEYS.CRUD.ENTER_PSEUDO_ID)"
                  formControlName="pseudoId"
                  name="pseudoId">
              </ng-container>

              <!-- Customer Nr -->
              <ng-container *ngIf="position.fieldKey === 'customerNr'">
                <label for="customerNr" [title]="_(KEYS.CRUD.ID)">{{_(KEYS.CRUD.ID)}}</label>
                <input
                  class="form-control"
                  id="customerNr"
                  [placeholder]="_(KEYS.CRUD.ENTER_PATIENT_ID)"
                  formControlName="customerNr"
                  name="customerNr">
              </ng-container>

              <!-- Case Nr -->
              <ng-container *ngIf="position.fieldKey === 'caseNr'">
                <label for="caseNr" [title]="_(KEYS.CRUD.CASE_NUMBER)">{{_(KEYS.CRUD.CASE_NUMBER)}}</label>
                <input
                  class="form-control"
                  id="caseNr"
                  [placeholder]="_(KEYS.CRUD.ENTER_CASE_NUMBER)"
                  formControlName="caseNr"
                  name="caseNr">
              </ng-container>

              <!-- Status -->
              <ng-container *ngIf="position.fieldKey === 'status'">
                <label for="status" [title]="_(KEYS.CRUD.STATUS)">{{_(KEYS.CRUD.STATUS)}}</label>
                <input
                  class="form-control"
                  id="status"
                  [placeholder]="_(KEYS.CRUD.ENTER_STATUS)"
                  formControlName="status"
                  name="status">
              </ng-container>

              <!-- Locale -->
              <ng-container *ngIf="position.fieldKey === 'locale'">
                <label for="locale" [title]="_(KEYS.CRUD.LANGUAGE)">
                  {{_(KEYS.CRUD.LANGUAGE)}}
                  <i class="fa fa-flag" ngbTooltip="{{_(KEYS.CRUD.LANGUAGE)}}"></i>
                </label>
                <select class="form-control" id="locale" formControlName="locale">
                  <ng-container *ngFor="let loc of objectKeys(languages)">
                    <option [value]="loc">{{translateLanguage(languages[loc])}}</option>
                  </ng-container>
                </select>
              </ng-container>

              <!-- Allow Mail -->
              <ng-container *ngIf="position.fieldKey === 'allowMail' && feature.patient.app.mail && isSurveyMailConfigured">
                <label for="allowMail" [title]="_(KEYS.CRUD.ALLOW_MAIL_OPTION)">
                  {{_(KEYS.CRUD.ALLOW_MAIL_OPTION)}}&nbsp;
                  <i class="fa fa-info-circle" ngbTooltip="{{_(KEYS.CRUD.ALLOW_MAIL_TOOLTIP)}}"></i>
                </label>
                <select class="form-control" id="allowMail" formControlName="allowMail">
                  <option value="true">{{_(KEYS.CRUD.YES)}}</option>
                  <option value="false">{{_(KEYS.CRUD.NO)}}</option>
                </select>
              </ng-container>

              <!-- Prefill -->
              <ng-container *ngIf="position.fieldKey === 'prefill'">
                <label for="prefill" [title]="_(KEYS.CRUD.PREFILL)">
                  {{_(KEYS.CRUD.PREFILL)}}&nbsp;
                  <i class="fa fa-info-circle" ngbTooltip="{{_(KEYS.CRUD.PREFILL_TOOLTIP)}}"></i>
                </label>
                <select class="form-control" id="prefill" formControlName="prefill">
                  <option value="yes">{{_(KEYS.CRUD.YES)}}</option>
                  <option value="no">{{_(KEYS.CRUD.NO)}}</option>
                  <option value="optional">{{_(KEYS.CRUD.OPTIONAL)}}</option>
                </select>
              </ng-container>
            </div>
          </ng-container>

          <!-- Custom field -->
          <ng-container *ngIf="position.fieldType === 'custom'">
            <ng-container *ngIf="getCustomDefinition(position.fieldKey) as def">
              <div
                class="grid-field-cell form-group"
                [style.grid-column]="getGridColumn(position)"
                [style.grid-row]="getGridRow(position)"
                [formGroup]="customFieldsForm"
              >
                <!-- Text input -->
                <ng-container *ngIf="def.type === 'text'">
                  <label [for]="'custom_' + def.key" [title]="def.label">{{def.label}}</label>
                  <input
                    type="text"
                    class="form-control"
                    [id]="'custom_' + def.key"
                    [formControlName]="def.key"
                    [ngClass]="{'is-invalid': isCustomFieldInvalid(def.key)}"
                  >
                  <div class="invalid-feedback" *ngIf="isCustomFieldInvalid(def.key)">
                    {{getCustomFieldHint(def)}}
                  </div>
                </ng-container>

                <!-- Number input -->
                <ng-container *ngIf="def.type === 'number'">
                  <label [for]="'custom_' + def.key" [title]="def.label">{{def.label}}</label>
                  <input
                    type="number"
                    class="form-control"
                    [id]="'custom_' + def.key"
                    [formControlName]="def.key"
                    [ngClass]="{'is-invalid': isCustomFieldInvalid(def.key)}"
                  >
                  <div class="invalid-feedback" *ngIf="isCustomFieldInvalid(def.key)">
                    {{getCustomFieldHint(def)}}
                  </div>
                </ng-container>

                <!-- Date input -->
                <ng-container *ngIf="def.type === 'date'">
                  <label [for]="'custom_' + def.key" [title]="def.label">{{def.label}}</label>
                  <input
                    type="date"
                    class="form-control"
                    [id]="'custom_' + def.key"
                    [formControlName]="def.key"
                    [ngClass]="{'is-invalid': isCustomFieldInvalid(def.key)}"
                  >
                  <div class="invalid-feedback" *ngIf="isCustomFieldInvalid(def.key)">
                    {{getCustomFieldHint(def)}}
                  </div>
                </ng-container>

                <!-- Select/Dropdown -->
                <ng-container *ngIf="def.type === 'select'">
                  <label [for]="'custom_' + def.key" [title]="def.label">{{def.label}}</label>
                  <select
                    class="form-control"
                    [id]="'custom_' + def.key"
                    [formControlName]="def.key"
                    [ngClass]="{'is-invalid': isCustomFieldInvalid(def.key)}"
                  >
                    <option [value]="null">-</option>
                    <ng-container *ngFor="let opt of def.options">
                      <option [value]="opt.value">{{opt.label}}</option>
                    </ng-container>
                  </select>
                  <div class="invalid-feedback" *ngIf="isCustomFieldInvalid(def.key)">
                    {{getCustomFieldHint(def)}}
                  </div>
                </ng-container>

                <!-- Boolean (as Dropdown) -->
                <ng-container *ngIf="def.type === 'boolean'">
                  <label [for]="'custom_' + def.key" [title]="def.label">{{def.label}}</label>
                  <select
                    class="form-control"
                    [id]="'custom_' + def.key"
                    [formControlName]="def.key"
                    [ngClass]="{'is-invalid': isCustomFieldInvalid(def.key)}"
                  >
                    <option [ngValue]="false">{{_(KEYS.CRUD.NO)}}</option>
                    <option [ngValue]="true">{{_(KEYS.CRUD.YES)}}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isCustomFieldInvalid(def.key)">
                    {{getCustomFieldHint(def)}}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

        </ng-container>
      </div>
    </form>
    <div class="group-hr2"><hr></div>
  </div>

  <!-- Anonymous/pseudonymous mode options -->
  <div
    *ngIf="(hideForm || patientForm.get('anonymous').value || patientForm.get('pseudonymous').value) && feature.patient.app.mail && isSurveyMailConfigured"
    [formGroup]="patientForm"
    style="width: 200px"
  >
    <div class="form-group">
      <label for="state">
        {{_(KEYS.CRUD.ALLOW_MAIL_OPTION)}}&nbsp;
        <i class="fa fa-info-circle" ngbTooltip="{{_(KEYS.CRUD.ALLOW_MAIL_TOOLTIP)}}"></i>
      </label>
      <select class="form-control" formControlName="allowMail">
        <option value="true">{{_(KEYS.CRUD.YES)}}</option>
        <option value="false" selected>{{_(KEYS.CRUD.NO)}}</option>
      </select>
    </div>

    <div class="form-group">
      <label for="prefill">
        {{_(KEYS.CRUD.PREFILL)}}&nbsp;
        <i class="fa fa-info-circle" ngbTooltip="{{_(KEYS.CRUD.PREFILL_TOOLTIP)}}"></i>
      </label>
      <select class="form-control" id="prefill" formControlName="prefill">
        <option value="yes">{{_(KEYS.CRUD.YES)}}</option>
        <option value="no" selected>{{_(KEYS.CRUD.NO)}}</option>
        <option value="optional">{{_(KEYS.CRUD.OPTIONAL)}}</option>
      </select>
    </div>
    <div class="group-hr2"><hr></div>
  </div>

  <div class="bottom mt-2" [ngClass]="{'new-patient': !patientForm.get('uid').value}">

    <div class="form-group" class="group-questionnaires">
      <div class="mt-2">
        <app-questionnaire-select
          [enableGroups]="true"
          [enableWorkflows]="true"
          [selectedWorkflowId]="selectedWorkflow"
          [selected]="selectedQuestionnaires"
          (selectWorkflow)="onWorkflowSelect($event)"
          (selectedChange)="onQuestionnairesSelect($event)">
        </app-questionnaire-select>
      </div>
    </div>

    <div class="group-qr mt-2 qrcode">
      <app-qr-code-display
        [patientUid]="patientForm.get('uid').value"
        [locale]="patientForm.get('locale').value || locale"
        [qrFillLink]="qrFillLink"
        [dirty]="dirty"
        [hasQuestionnaires]="selectedQuestionnaires.length > 0"
        [qrMode]="qrMode"
        (modeChanged)="onQrModeChanged($event)"
      ></app-qr-code-display>
    </div>
  </div>
  <br><br><br>
</div>

<div [ngClass]="{'btn-footer': !overlayMode}">
  <app-patient-action-buttons
    [patientForm]="patientForm"
    [customFieldsForm]="customFieldsForm"
    [selectedQuestionnaires]="selectedQuestionnaires"
    [dirty]="dirty"
    [feature]="feature"
    [overlayMode]="overlayMode"
    [hideForm]="hideForm"
    [isSurveyMailConfigured]="isSurveyMailConfigured"
    [disableUserToggle]="disableUserToggle"
    [showCloseWinBtn]="showCloseWinBtn"
    (save)="onSubmit()"
    (toggleAnonymous)="onToggleAnonymous()"
    (togglePseudonymous)="onTogglePseudonymous()"
    (createJumpInCode)="onCreateJumpInCode()"
    (fillStart)="onFillStart()"
    (copyLink)="onFillCopyClipboard()"
    (sendMail)="onSendMail()"
  ></app-patient-action-buttons>
</div>
